module.exports = __webpack_public_path__ + "static/media/riskM.960ce1ca.svg";